<template>
  <div class="List">
    <ul>
      <li v-for="(item,index) in list" v-if="index<Show">
        <div class="title" :class="{ time: ShowTime}">
          <router-link :to="{ name: 'wz',params: { ret:name , nr:item.value}}" v-if="name!=='jys'">{{item.title}}
          </router-link>
          <a :href="item.jump" v-if="name==='jys'">{{item.title}}
          </a>
        </div>
        <div class="rq" v-if="ShowTime">{{item.ctime}}</div>
      </li>
    </ul>
    <ShowMore :listall="list.length" :listshow.sync="Show" :count="count"></ShowMore>
  </div>
</template>

<script>
  import ShowMore from '@/components/ShowMore/ShowMore'
  export default {
    name: 'List',
    data () {
      return {
        Show: this.count
      }
    },
    props: {
      count: {
        type: Number,
        default: 10
      },
      list: {
        type: Array
      },
      name: {
        type: String
      },
      ShowTime: {
        type: Boolean,
        default: false
      }
    },
    components: {
      ShowMore
    },
    methods: {
      setCjwtShowIndex: function (index) {
        if (this.CjwtShowIndex !== index) this.CjwtShowIndex = index
        else this.CjwtShowIndex = -1
      }
    },
    watch: {
      list: function () {
        this.Show = this.count
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus">
  @import "../../common/stylus/common.styl"
  .List
    ul
      li
        line-height 43px
        font-size 13px
        color $font_color1
        margin 0 $bj 0 $bj
        border-bottom solid 1px #cccccc
        .title
          width 100%
          white-space: nowrap
          overflow: hidden
          text-overflow: ellipsis
          &.time
            margin-left 13px
        .rq
          text-align right
          line-height 13px
          margin-bottom 14px
</style>



// WEBPACK FOOTER //
// List.vue?5d3b67e9